import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import {
  HelpDocLink,
  ReactFormInput,
  ReactFormSelect,
} from '../../../../components';
import StepModalCaption from '../../../../components/modal/StepModalCaption/StepModalCaption';
import lightHouseArticles from '../../../../configs/lightHouseArticles';
import useStyles from './styles';
import { durationOptions, firstEditOptions } from './constants';
import useOrderSameDay from '../../../../hooks/useOrderSameDay';
import ReactFormRadioGroup from '../../../../components/form-radio-group/ReactFormRadioGroup';
import VideoEditOrderCheckForm from '../../../../components/video-edit-order-check/VideoEditOrderCheckForm';

type Props = {
  setModalTitle: (title: string) => void;
};

const StepTwo = ({ setModalTitle }: Props) => {
  const classes = useStyles();
  const { watch, setValue } = useFormContext();
  const videoDuration = watch('options.video_duration_key');
  const orderTitle = watch('options.order_title');
  const sceneTitle = watch('options.scene_title');

  const videoDurationMin = watch('options.additional_min');
  const firstEditId = watch('first_edit_delivery_id');
  const additionalMinutes = videoDuration === 3 ? videoDurationMin - 5 : 0;
  const firstEditPrice = firstEditId === 'overnight' ? 0 : 50;
  const totalPrice = additionalMinutes * 10 + firstEditPrice;
  const isDevMode = process.env.REACT_APP_BUILD_ENV === 'development';
  const isAllowedSameDay = useOrderSameDay() && isDevMode;
  if (!isDevMode) {
    firstEditOptions.splice(1, 1);
  }

  useEffect(() => {
    setModalTitle(orderTitle || sceneTitle || 'New Video Edit Order');
  }, [setModalTitle, orderTitle, sceneTitle]);

  useEffect(() => {
    setValue('options.total_price', totalPrice);
  }, [totalPrice, setValue]);

  useEffect(() => {
    if (!isAllowedSameDay) {
      setValue('first_edit_delivery_id', 'overnight');
    }
  }, [isAllowedSameDay, setValue]);

  return (
    <Grid container spacing={4} className={classes.stepContainer}>
      <Grid item md={6} xs={12} className={classes.leftContainer}>

        <Grid item xs={12}>
          <Grid item xs={12} className={classes.inputWrapper}>
            <ReactFormSelect
              items={durationOptions}
              name="options.video_duration_key"
              label="Desired Duration"
              tooltip="What range of duration do you think the video will be in?"
            />
          </Grid>
          { videoDuration === 3 && (
            <Grid item xs={12} className={classes.inputWrapper}>
              <ReactFormInput
                name="options.additional_min"
                label="How many minutes?"
                endAdornment="minutes"
                type="number"
                tooltip="How many total minutes do you expect the video to be?"
                inputProps={{ min: 6, max: 999 }}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <StepModalCaption
              title="First Edit"
              tooltip="The First Edit is the first video edit effort.
                       There might be other changes which need to be made after the First Edit & before
                       he video is ready to publish."
            />
            <ReactFormRadioGroup
              name="first_edit_delivery_id"
              options={firstEditOptions}
              blockedIds={isAllowedSameDay ? [] : ['same_day']}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} className={classes.helpLinkWrapper}>
          <span>
          Questions about the order?
            <HelpDocLink id={lightHouseArticles.createOrder}> Find help.</HelpDocLink>
          </span>
        </Grid>
      </Grid>
      <Grid item md={6} xs={12}>
        <VideoEditOrderCheckForm inModal />
      </Grid>
    </Grid>
  );
};

export default StepTwo;
